import React, { useState } from 'react';
import { Button, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useMSALHelper } from '@/hooks/useMSALHelper';
import { useNavVariant } from '@/components/layouts/navVariants';
import { UserMenu } from './UserMenu';

export const AccountMenuButton = () => {
	const theme = useTheme();
	const [anchorEl, setAnchorEl] = useState(null);
	const { handleLogout } = useMSALHelper();

	const { AccountAvatar, AccountLabel } = useNavVariant();

	const handleOpen = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	const handleSignOut = () => {
		handleClose();
		handleLogout();
	};

	return (
		<div>
			<Button
				variant='text'
				size='small'
				sx={{
					fontWeight: 700,
					fontSize: '1em',
					color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',
					textTransform: 'none',
				}}
				aria-controls='menu-appbar'
				aria-haspopup='true'
				startIcon={<AccountAvatar />}
				endIcon={<KeyboardArrowDownIcon />}
				onClick={handleOpen}
			>
				<AccountLabel />
			</Button>
			<UserMenu anchorEl={anchorEl} onClose={handleClose} onSignOut={handleSignOut} />
		</div>
	);
};
